 <template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
<!-- Breadcrumb y ayuda -->    
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/atencion">Atenciones</router-link>
            > Atención {{ datoAtencion.numero }}
          </div>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda del formulario de atención"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>
<!-- Area de notificación -->    
<!--     <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
      <div class="notification-message"
        :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
        {{ notificacion.message }}
      </div>
    </div> -->
<Modal v-model:modelValue="showModalHelp" title="Ayuda — Formulario de Atención">
  <AyudaAtencionForm />
</Modal>
    <Modal v-model:modelValue="showModal">
      <AtencionResumen :p_idAtencion="p_idAtencion"/>
    </Modal>
<!--
    <Modal v-model:modelValue="showModalDoc">
      <DocVerFirmar :idReporte="1" :idDocumento="81"/>
    </Modal>
    <Modal v-model:modelValue="showModalDocSave">
      <DocVerFirmarGuardar :idReporte="1" :idDocumento="81"/>
    </Modal>
    <Modal v-model:modelValue="showModalDocMail">
      <DocVerFirmarEnviar :idReporte="1" :idDocumento="81"/>
    </Modal>
-->
    <Modal v-model:modelValue="showModalDocumentos">
      <EnviarDocumentos :p_idAtencion="datoAtencion.idAtencion" 
                        :p_idPersona="datoAtencion.idPersona"
                        :p_numero="datoAtencion.numero"
                        :p_nombreEspecialidad="ESPECIALIDAD"
                        :p_fechaCita="datoAtencion.fechaCita"/>
    </Modal>
    <hr>
    <!-- Master -->
    <div class="modal-dialog modal-xl" style="z-index: 1;">
      <div class="modal-content" v-if="datoAtencion.idAtencion">
        <div class="d-flex justify-content-between align-items-center">
          <b>Datos Generales de la Atención</b>
          <button
            class="btn btn-link p-0 text-decoration-none"
            @click.prevent="mostrarOcultarBloqueA"
          >
            <span class="material-symbols-outlined align-middle">
              {{ mostrarBloqueA ? 'expand_less' : 'expand_more' }}
            </span>
            {{ mostrarBloqueA ? 'Mostrar menos información' : 'Mostrar más información' }}
          </button>
        </div>
        <div v-if="mostrarBloqueA" class="mb-3">
        <form>
          <div class="modal-body form-card">
            <div class="row">
              <!-- Columna para el contenido principal -->
              <div class="col-md-9">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-1">
                      <label for="tipo" class="form-label">Tipo</label>
                    </div>
                    <div class="col-2">
                      <select class="form-select" id="tipo" name="tipo" v-model="datoAtencion.tipo"
                      :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
                        <option value="I">Inicial</option>
                        <option value="S">Subsecuente</option>
                      </select>
                    </div>
                    <div class="col-1">
                      <label for="estadoAtencion" class="form-label">Estado</label>
                    </div>
                    <div class="col-3">
                      <input type="text" class="form-control" id="estadoAtencion" name="estadoAtencion"
                        v-model="datoAtencion.estadoAtencion" disabled>
                    </div>
                    <div class="col-1">
                      <label for="edadTexto" class="form-label">Edad</label>
                    </div>
                    <div class="col-4">
                      <input type="text" class="form-control" id="edadTexto" name="edadTexto"
                        v-model="edadTexto" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-1">
                      <label for="nombrePaciente" class="form-label">Paciente</label>
                    </div>
                    <div class="col-6">
                      <input type="text" class="form-control" id="nombrePaciente" name="nombrePaciente"
                        v-model="datoAtencion.nombrePaciente" disabled>
                    </div>
                    <div class="col-1">
                      <label for="documentoPaciente" class="form-label">Cédula</label>
                    </div>
                    <div class="col-4">
                      <input type="text" class="form-control" id="documentoPaciente" name="documentoPaciente"
                        v-model="datoAtencion.documentoPaciente" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-1">
                      <label for="nombreMedico" class="form-label"> Médico</label>
                    </div>
                    <div class="col-6">
                      <input type="text" class="form-control" id="nombreMedico" name="nombreMedico"
                        v-model="datoAtencion.nombreMedico" disabled>
                    </div>
                    <div class="col-1">
                      <label for="nombreEspecialidad" class="form-label">Especial.</label>
                    </div>
                    <div class="col-4">
                      <input type="text" class="form-control" id="nombreEspecialidad" name="nombreEspecialidad"
                        v-model="datoAtencion.nombreEspecialidad" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-1">
                      <label for="nombreMotivoCita" class="form-label">Motivo</label>
                    </div>
                    <div class="col-11">
                      <input type="text" class="form-control" id="nombreMotivoCita" name="nombreMotivoCita"
                        v-model="datoAtencion.nombreMotivoCita" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-12">
                      <label for="motivo" class="form-label">Descripción del Motivo</label>

                      <div class="textarea-container-mic d-flex align-items-stretch">
                        <textarea class="form-control" id="motivo" name="motivo" v-model="datoAtencion.motivo"
                          style='text-transform:uppercase'						  
                          :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'"
                          @input="handleChange('motivo')"
                          @blur="handleBlur('motivo')"
                          maxlength="250">
                        </textarea>

                        <div class="buttons-container-mic d-flex flex-column ms-2" style="height: auto;">
                          <button v-if="!isDictatingMotivo" @click="startDictation('motivo')" type="button" class="btn btn-light" title="Iniciar Dictado"
                          :disabled="(datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO') || isDictatingMotivo">
                            <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                          </button>
                          <button v-else @click="stopDictation('motivo')" type="button" class="btn btn-light" title="Finalizar Dictado"
                          :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
                            <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                          </button>

                          <div class="flex-grow-1"></div>
                          <small class="text-muted mt-auto text-end">
                            {{ (datoAtencion.motivo || '').length }} / 250
                          </small>

                        </div>
						
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="row">
                    <div class="col-12">
                      <label for="cuadro" class="form-label">Cuadro Clínico (Enfermedad o Problema Actual)</label>

                      <div class="textarea-container-mic d-flex align-items-stretch">
                        <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoAtencion.cuadro"
                          style='text-transform:uppercase'
                          :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'"
                          @input="handleChange('cuadro')"
                          @blur="handleBlur('cuadro')"
                          maxlength="4000">
                        </textarea>

                        <div class="buttons-container-mic d-flex flex-column ms-2" style="height: auto;">
                          <button v-if="!isDictatingCuadro" @click="startDictation('cuadro')" type="button" class="btn btn-light" title="Iniciar Dictado"
                          :disabled="(datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO') || isDictatingCuadro">
                            <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                          </button>
                          <button v-else @click="stopDictation('cuadro')" type="button" class="btn btn-light" title="Finalizar Dictado"
                          :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
                            <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                          </button>

                          <div class="flex-grow-1"></div>
                          <small class="text-muted mt-auto text-end	">
                            {{ (datoAtencion.cuadro || '').length }} / 4000
                          </small>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr>
                <div class="buttons-container">
                  <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
                  <div class="right-aligned-buttons">
                    <div
                      :title="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO' ? 'No se puede actualizar atenciones finalizadas' : 'Actualizar'">
<!--					  
                      <button type="submit" class="btn btn-success"
                        @click.prevent="datoAtencion.estadoAtencion !== 'FINALIZADA' && actualizarAtencion('PROCESO')"
                        :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
                        <span class="material-symbols-outlined" style="font-size:24px; cursor: pointer;">update</span>
                        Actualizar
                      </button>					  
                      <div
                        :title="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO' ? 'La atención ya está finalizada' : 'Finalizar'">
                        <button type="button" class="btn btn-warning mb-1 w-100" @click="actualizarAtencion('FINALIZADA')"
                        :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
                          <span class="material-symbols-outlined" style="font-size: 20px; color: blue;">task</span>
                          Finalizar
                        </button>
                      </div>
-->
<div class="d-flex align-items-center gap-2">
  
  <button
    type="submit"
    class="btn btn-success d-flex align-items-center gap-1"
    @click.prevent="datoAtencion.estadoAtencion !== 'FINALIZADA' && actualizarAtencion('PROCESO')"
    :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
    <span class="material-symbols-outlined">update</span>
    Actualizar
  </button>

  <button
    type="button"
    class="btn btn-warning d-flex align-items-center gap-1"
    :title="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'
      ? 'La atención ya está finalizada'
      : 'Finalizar'"
    @click="actualizarAtencion('FINALIZADA')"
    :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
    <span class="material-symbols-outlined">task</span>
    Finalizar
  </button>

</div>
                    </div>
                  </div>
                </div>
                <div v-if="mostrarBloque" class="mb-3">
                  <hr>
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-12">
                        <label for="observacion" class="form-label">Texto del Certificado Médico</label>
                        <div class="textarea-container-mic d-flex align-items-stretch">
                          <textarea class="form-control" id="observacion" name="observacion"
                            v-model="datoAtencion.observacion" style='text-transform:uppercase' maxlength="250"
                            :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'"></textarea>
							
                          <div class="buttons-container-mic d-flex flex-column ms-2" style="height: auto;">
                            <button v-if="!isDictatingObservacion" @click="startDictation('observacion')" type="button" class="btn btn-light" title="Iniciar Dictado"
                              :disabled="(datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO') || isDictatingObservacion">
                              <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                            </button>
                            <button v-else @click="stopDictation('observacion')" type="button" class="btn btn-light" title="Finalizar Dictado"
                              :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
                              <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                            </button>

                            <div class="flex-grow-1"></div>
                            <small class="text-muted mt-auto text-end">
                              {{ (datoAtencion.observacion || '').length }} / 250
                            </small>

                          </div>							
                        </div>
                      </div>
                    </div>
                  </div> 
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-9">
                        <label for="idMotivo" class="form-label">Motivo de finalización sin diagnóstico definitivo</label>
                        <select class="form-select" id="idMotivo" name="idMotivo" v-model="datoAtencion.idMotivo"
                                :disabled="datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO'">
                          <option v-for="motivo in motivos" :value="motivo.idMotivo" :key="motivo.idMotivo">
                            {{ motivo.nombre }}
                          </option>
                        </select>
                      </div>
                      <div class="col-3 d-flex flex-column justify-content-end">
                        <button class="btn btn-secondary mt-2" @click="resetSelection" 
                                :disabled="!datoAtencion.idMotivo || (datoAtencion.estadoAtencion != 'PENDIENTE' && datoAtencion.estadoAtencion != 'PROCESO')">
                          Eliminar Selección
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="idAtencion" class="form-label">Id. Atención</label>
                        <input type="text" class="form-control" id="idAtencion" name="idAtencion"
                          v-model="datoAtencion.idAtencion" disabled>
                      </div>
                      <div class="col-5">
                        <label for="fechaReg" class="form-label">Fecha de Registro</label>
                        <input type="text" class="form-control" id="fechaReg" name="fechaReg"
                          :value="getFormattedDate(datoAtencion.fechaReg)" disabled>
                      </div>
                      <div class="col-5">
                        <label for="fechaAct" class="form-label">Fecha de Actualización</label>
                        <input type="text" class="form-control" id="fechaAct" name="fechaAct"
                          :value="getFormattedDate(datoAtencion.fechaAct)" disabled>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-1 d-none d-md-block"></div>
              <div class="col-12 col-md-2 mt-3 mt-md-0">
                <div class="d-flex flex-column align-items-start">
<button
  v-if ="datoAtencion.tipoMotivoCita == 'O'"
  type="button" class="btn btn-outline-secondary mb-1 w-100"
  @click.prevent="verAtencionObstetrica"
  title="Abrir Atención Obstétrica">
  <span class="material-symbols-outlined" style="font-size:20px;color:fuchsia; cursor: pointer;">pregnancy</span>
  Atención Obstétrica
</button>
<button
  v-if="datoAtencion.idEspecialidad == 52"
  type="button" class="btn btn-outline-secondary mb-1 w-100"
  @click="abrirModalEspecialidad('odontograma')"
  title="Abrir Odontograma">
  <span class="material-symbols-outlined" style="font-size: 20px;">dentistry</span>
  Odontograma
</button>
<button
  v-if="datoAtencion.idEspecialidad == 53"
  type="button" class="btn btn-outline-secondary mb-1 w-100"
  @click="abrirModalEspecialidad('oftalmologia')"
  title="Abrir Oftalmología">
  <span class="material-symbols-outlined" style="font-size: 20px;">visibility</span>
  Oftalmología
</button>
<button
  v-if="datoAtencion.idEspecialidad == 54"
  type="button" class="btn btn-outline-secondary mb-1 w-100"
  @click="abrirModalEspecialidad('otorrinolaringologia')"
  title="Abrir Otorrinolaringología">
  <span class="material-symbols-outlined" style="font-size: 20px;">hearing</span>
  ORL
</button>
<button
  v-if="datoAtencion.idEspecialidad == 1"
  type="button" class="btn btn-outline-secondary mb-1 w-100"
  @click="abrirModalEspecialidad('rehabilitacion')"
  title="Abrir Rehabilitación">
  <span class="material-symbols-outlined" style="font-size: 20px;">physical_therapy</span>
  Rehabilitación
</button>
                  <button type="button" class="btn btn-outline-primary mb-1 w-100" @click="verInterconsulta()"
                    title="Gestionar interconsultas de la atención médica seleccionada">
                    <span class="material-symbols-outlined" style="font-size: 20px;">groups</span>
                    Interconsultas
                  </button>
                  <button type="button" class="btn btn-outline-primary mb-1 w-100" @click="verReferencia()"
                    title="Gestionar referencias o derivaciones de la atención médica seleccionada">
                    <span class="material-symbols-outlined" style="font-size: 20px;">groups</span>
                    Ref./Der.
                  </button>
                  <button type="button" class="btn btn-outline-primary mb-1 w-100" @click="verAlergias()"
                    title="Consultar alergias del paciente">
                    <span class="material-symbols-outlined" style="font-size: 20px;">allergies</span>
                    Alergias
                  </button>
                  <button type="button" class="btn btn-outline-primary mb-1 w-100" @click="verVacunas()"
                    title="Consultar esquema de vacunas del paciente">
                    <span class="material-symbols-outlined" style="font-size: 20px;">vaccines</span>
                    Vacunas
                  </button>
                  <button type="button" class="btn btn-outline-primary mb-1 w-100" @click="showModal = true" title="Ver datos de la atención médica y notas clínicas">
                    <span class="material-symbols-outlined" style="font-size: 20px;">clinical_notes</span>
                    Ver Atención
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary mb-1 w-100" @click="mostrarConsentimiento = true"
                    title="Generar y firmar consentimiento informado del paciente">
                    <span class="material-symbols-outlined" style="font-size: 20px;">clinical_notes</span>
                    Consentimiento
                  </button>
                  <button type="button" class="btn btn-outline-secondary mb-1 w-100" @click="abrirIndicacionesPDF()"
                    title="Generar y descargar indicaciones médicas en PDF">
                    <span class="material-symbols-outlined" style="font-size: 20px; color: red;">picture_as_pdf</span>
                    Indicaciones
                  </button>
                  <button type="button" class="btn btn-outline-secondary mb-1 w-100" @click="abrirCertificadoPDF()"
                    title="Generar y descargar certificado médico en PDF">
                    <span class="material-symbols-outlined" style="font-size: 20px; color: red;">picture_as_pdf</span>
                    Certificado
                  </button>
                  <button type="button" class="btn btn-outline-info mb-1 w-100" @click="showModalDocumentos = true"
                    title="Enviar documentos PDF de la atención médica seleccionada">
                    <span class="material-symbols-outlined" style="font-size: 20px; color: darkorange;">attach_email</span>
                    Enviar (pdf)
                  </button>
                  <button type="submit" class="btn btn-outline-primary mb-1 w-100" @click.prevent="agendarCita()"
                    title="Agendar cita médica para el paciente de la atención seleccionada">
                    <i class="material-icons"
                      style="font-size:20px;color:green; cursor: pointer;">calendar_month</i>Agendar Cita
                  </button>	
                </div>
              </div>
            </div>
          </div>
        </form>
        </div>
      </div>
    </div>
<!-- Estructura de Tabs -->
<div class="tab-bar mt-3">
  <button class="tablink" @click="showTable = 'biomAten'"
    :class="{ 'active-tab': showTable === 'biomAten' }">
    <span class="material-symbols-outlined">monitor_heart</span>
    Constantes Vitales
  </button>
  <button class="tablink" @click="showTable = 'anteAten'"
    :class="{ 'active-tab': showTable === 'anteAten' }">
    <span class="material-symbols-outlined">history_edu</span>
    Antecedentes
  </button>
  <button class="tablink" @click="showTable = 'anatAten'"
    :class="{ 'active-tab': showTable === 'anatAten' }">
    <span class="material-symbols-outlined">accessibility_new</span>
    Órganos y Sistemas
  </button>
  <button class="tablink" @click="showTable = 'examAten'"
    :class="{ 'active-tab': showTable === 'examAten' }">
    <span class="material-symbols-outlined">stethoscope</span>
    Examen Físico
  </button>
  <button class="tablink" @click="showTable = 'diagAten'"
    :class="{ 'active-tab': showTable === 'diagAten' }">
    <span class="material-symbols-outlined">diagnosis</span>
    Diagnósticos
  </button>
  <button class="tablink" @click="showTable = 'tratamiento'"
    :class="{ 'active-tab': showTable === 'tratamiento' }">
    <span class="material-symbols-outlined">medication</span>
    Plan de Tratamiento
  </button>
  <button class="tablink" @click="showTable = 'atencionDet'"
    :class="{ 'active-tab': showTable === 'atencionDet' }"
    title="Servicios y Recursos de Atención: procedimientos, exámenes, medicamentos e insumos.">
    <span class="material-symbols-outlined">list_alt</span>
    Detalle
  </button>
</div>

    <!-- Contenido dinámico según la pestaña seleccionada -->
    <div v-if="showTable === 'biomAten'">
      <BiomAten :p_idAtencion="Number(p_idAtencion)"
                :p_idPersona="datoAtencion.idPersona"
                :p_numero="datoAtencion.numero"
                :p_estadoAtencion="datoAtencion.estadoAtencion"
                :p_sexo="datoAtencion.sexoPaciente"
                :p_EdadYears="datoAtencion.edadAteYears"
                :p_EdadMonths="datoAtencion.edadAteMonths"
                :p_EdadDays="datoAtencion.edadAteDays"></BiomAten>
    </div>
    <div v-if="showTable === 'anteAten'">
      <AnteAten :p_idAtencion="p_idAtencion" :p_estadoAtencion="datoAtencion.estadoAtencion" :p_tipoMotivoCita="datoAtencion.tipoMotivoCita"></AnteAten>
    </div>
    <div v-if="showTable === 'anatAten'">
      <AnatAten :p_idAtencion="p_idAtencion" :p_estadoAtencion="datoAtencion.estadoAtencion"></AnatAten>
    </div>
    <div v-if="showTable === 'examAten'">
      <ExamAten :p_idAtencion="p_idAtencion" :p_estadoAtencion="datoAtencion.estadoAtencion"></ExamAten>
    </div>
    <div v-if="showTable === 'diagAten'">
      <DiagAten :p_idAtencion="p_idAtencion" :p_estadoAtencion="datoAtencion.estadoAtencion"></DiagAten>
    </div>
    <div v-if="showTable === 'tratamiento'">
      <TratamientoForm :p_idAtencion="p_idAtencion" :p_estadoAtencion="datoAtencion.estadoAtencion" :p_numero="datoAtencion.numero"></TratamientoForm>
    </div>
    <div v-if="showTable === 'atencionDet'">
      <AtencionDet :p_idAtencion="p_idAtencion" :p_estadoAtencion="datoAtencion.estadoAtencion"></AtencionDet>
    </div>
    <!-- Consentimiento Informado -->
    <ConsentimientoModal
      v-model:visible="mostrarConsentimiento"
      :id-atencion="Number(p_idAtencion)"
      @firmado="onConsentimientoFirmado"
    />

<!-- Modal Especialidades -->
<div v-if="modalEspecialidad" class="modal-especialidad-overlay" @click.self="cerrarModalEspecialidad">
  <div class="modal-especialidad-dialog">
    <div class="modal-especialidad-header">
      <span class="material-symbols-outlined">
        {{ modalEspecialidad === 'odontograma' ? 'dentistry' : modalEspecialidad === 'oftalmologia' ? 'visibility' : 'hearing' }}
      </span>
      <strong>
        {{ modalEspecialidad === 'odontograma'          ? 'Odontograma'          :
           modalEspecialidad === 'oftalmologia'         ? 'Oftalmología'         :
           modalEspecialidad === 'otorrinolaringologia' ? 'Otorrinolaringología' :
           modalEspecialidad === 'rehabilitacion'       ? 'Rehabilitación'       : '' }}
      </strong>
      <button class="modal-especialidad-close" @click="cerrarModalEspecialidad" title="Cerrar">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
    <div class="modal-especialidad-body">
      <OdontogramaForm v-if="modalEspecialidad === 'odontograma'"
        :p_idAtencion="Number(p_idAtencion)"
        :p_estadoAtencion="datoAtencion.estadoAtencion" />
      <OftalmologiaForm v-if="modalEspecialidad === 'oftalmologia'"
        :p_idAtencion="Number(p_idAtencion)"
        :p_estadoAtencion="datoAtencion.estadoAtencion" />
      <OtorrinolaringologiaForm v-if="modalEspecialidad === 'otorrinolaringologia'"
        :p_idAtencion="Number(p_idAtencion)"
        :p_estadoAtencion="datoAtencion.estadoAtencion" />
      <RehabilitacionForm
        v-if="modalEspecialidad === 'rehabilitacion'"
        :p_idAtencion="Number(p_idAtencion)"
        :p_estadoAtencion="datoAtencion.estadoAtencion"
        :p_idMedico="datoAtencion.idMedico"/>
    </div>
  </div>Obs
</div>
    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AyudaAtencionForm from '@/views/ayuda/AyudaAtencionForm.vue'
import AtencionResumen from '@/views/reportes/AtencionResumen.vue';
import { validarForm } from '@/modules/validacionesForms.js'
import SpeechDictation from '@/modules/microfono.js';
import dateFormat from '@/modules/dateFormat.js';
import AtencionDet from '../forms/AtencionDet.vue';
import AnatAten from '../forms/AnatAten.vue';
import AnteAten from '../forms/AnteAten.vue';
import BiomAten from '../forms/BiomAten.vue';
import DiagAten from '../forms/DiagAten.vue';
import ExamAten from '../forms/ExamAten.vue';
import TratamientoForm from './TratamientoForm.vue';
import EnviarDocumentos from '../utils/EnviarDocumentos.vue';
import ConsentimientoModal from '@/views/consentimientos/ConsentimientoModal.vue';
import OdontogramaForm from '@/components/OdontogramaForm.vue';
import OftalmologiaForm from '@/components/OftalmologiaForm.vue';
import OtorrinolaringologiaForm from '@/components/OtorrinolaringologiaForm.vue';
import RehabilitacionForm from '@/components/RehabilitacionForm.vue';

import api    from "@/services/api";
import config from '@/config.js'

import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal2 from 'sweetalert2'

export default {
  components: {
    Layout, Footer, AyudaAtencionForm, AtencionResumen,
    AtencionDet, AnatAten, AnteAten, BiomAten, DiagAten, ExamAten, TratamientoForm, 
    EnviarDocumentos, ConsentimientoModal,
    OdontogramaForm, OftalmologiaForm, OtorrinolaringologiaForm, RehabilitacionForm
  },
  data() {
    return {
      atencions: [],
      datoAtencion: {},
/*
datoAtencion: {
  idAtencion: null,
  idEmpresa: null,
  idPersona: null,
  idMedico: null,
  idCita: null,
  idEspecialidad: null,
  idFactura: null,
  idAsiento: null,
  idMotivo: null,
  numero: null,
  motivo: '',
  tipo: '',
  estadoAtencion: '',
  cuadro: '',
  observacion: '',
  fechaCita: null,
  horaDesde: '',
  horaHasta: '',
  fechaReg: null,
  fechaAct: null,
  estado: 0,
  citaFechaReg: null,
  personaFechaReg: null,
  nombrePaciente: '',
  documentoPaciente: '',
  edadNacYears: '',
  edadNacMonths: '',
  edadNacDays: '',
  edadAteYears: '',
  edadAteMonths: '',
  edadAteDays: '',
  sexoPaciente: '',
  tituloProfesional: '',
  tituloEspecialidad: '',
  nombreMedico: '',
  documentoMedico: '',
  nombreEspecialidad: '',
  idMotivoCita: null,
  nombreMotivoCita: '',
  tipoMotivoCita: '',
},
*/
      datosCorreo: {},
      nombreBusqueda: '',
      titulo: '',
      //      btnCrear: false,
      //      btnEditar: true,
      modalWindow: true,
      mostrarBloqueA: true,
      mostrarBloque: false,
      p_idAtencion: 0,
      showTable: 'biomAten', // Pestaña por defecto
      dictation: new SpeechDictation(),
      isDictatingMotivo: false,
      isDictatingCuadro: false,
      isDictatingObservacion: false,
      motivos: [],
      showModal: false,
      showModalHelp: false,
      showModalDoc: false,
      showModalDocSave: false,
      showModalDocMail: false,
      showModalDocumentos: false,
      edadTexto: '',
      mostrarConsentimiento: false,
      modalEspecialidad: null,
      originalValues: {
        motivo: '',
        cuadro: ''
      },

      hasChanged: {
        motivo: false,
        cuadro: false
      },
    }
  },
async mounted() {
  this.p_idAtencion = this.$route.params.p_idatencion
  if (this.$route.query.tab) {
    this.showTable = this.$route.query.tab;
  }

  await Promise.all([
    this.getData(),
    this.fetchMotivos()
  ]);

  this.$refs.layoutRef.toggleProcesos()
  this.$refs.layoutRef.toggleReportes()
  this.$refs.layoutRef.toggleParametros()
  this.$refs.layoutRef.toggleAyuda()
},
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloqueA() {
      this.mostrarBloqueA = !this.mostrarBloqueA;
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    async getData() {
      await api.get('/vwatencions/' + this.p_idAtencion)
        .then(response => {
          this.datoAtencion = response.data;
        })
        .catch(error => {
          console.error('Error al obtener datos de la persona:', error);
        });

         this.edadTexto = this.datoAtencion.edadAteYears+' años, '+
                          this.datoAtencion.edadAteMonths+' meses, '+
                          this.datoAtencion.edadAteDays+' días';
    },
    validarFormulario() {
      const requiredFields = [
        'idPersona'
        , 'idMedico'
        , 'idCita'
        , 'tipo'
        , 'motivo'
        , 'observacion'
      ];
      const requiredFieldsText = [
        'idPersona'
        , 'idMedico'
        , 'idCita'
        , 'tipo'
        , 'motivo'
        , 'observacion'
      ];
      const requiredFieldsObs = [
        ''
        , ''
        , ''
        , 'Seleccione el tipo de la lista incluida en el elemento "Tipo"'
        , ''
        , ''
      ];
      return validarForm(this.datoAtencion, requiredFields, requiredFieldsText, requiredFieldsObs);
    },
    async actualizarAtencion(estado) {
      if (estado === "FINALIZADA") {
        swal2.fire({
          title: '¿Está seguro?',
          text: "¿Está seguro de que desea finalizar la atención?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            this.cambiarEstado(estado);
          }
        });
      } else {
        this.cambiarEstado(estado);
      }
    },
    async cambiarEstado(estado) {
      var estadoActual = this.datoAtencion.estadoAtencion;
      if (this.validarFormulario() === 1) {
        try {
          this.datoAtencion.estadoAtencion = estado;  
          console.log('tipo:', this.datoAtencion.tipo);
          await api.post('/atencions', this.datoAtencion);
          swal2.fire({
                    title: '¡Éxito!',
                    text: 'Atención actualizada exitosamente!',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                  });
        } catch (error) {
          this.datoAtencion.estadoAtencion = estadoActual;
          let title = 'Error';
          let message = '¡Inténtelo de nuevo!';
          if (error.response && error.response.status === 404) {
            title = 'Registro de diagnósticos requerido';
            message = error.response.data.message; // Suponiendo que el mensaje está en 'data.message'
          }          
          swal2.fire({
            title: title,
            text: message,
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      }
    },
    handleChange(field) {
      if (this.datoAtencion[field] !== this.originalValues[field]) {
        this.hasChanged[field] = true;
      }
    },
    handleBlur(field) {
      if (this.hasChanged[field]) {
        this.autosave(field);
        this.hasChanged[field] = false;
        this.originalValues[field] = this.datoAtencion[field];
      }
    },
    async autosave() {
      if (this.validarFormulario() === 1) {
        try {
          await api.post('/atencions', this.datoAtencion);
          console.log("GUARDADO: ");
        } catch (error) {
          console.log("ERROR: "+error.message);
        }
      }
    },
    verResumenAtencion(){
      this.$router.push('/tratamientoform/' + this.p_idAtencion + '/' + this.datoAtencion.numero);
    },
    verInterconsulta() {
      this.$router.push(`/atencion_interconsulta/${this.p_idAtencion}/${this.datoAtencion.estadoAtencion}/${this.datoAtencion.numero}`)
    },
    verReferencia() {
      this.$router.push(`/atencion_referencia/${this.p_idAtencion}/${this.datoAtencion.estadoAtencion}/${this.datoAtencion.numero}`)
    },
    verAlergias(){
      this.$router.push(`/persona_alergiapers/${this.p_idAtencion}/${this.datoAtencion.estadoAtencion}/${this.datoAtencion.numero}/${this.datoAtencion.idPersona}`)
    },
    verVacunas() {
      // Calcular la edad con mayor precisión (años, meses, días)
      const daysInYear = 365.25; // Considera los años bisiestos

      const years = parseInt(this.datoAtencion.edadNacYears, 10) || 0;
      const months = parseInt(this.datoAtencion.edadNacMonths, 10) || 0;
      const days = parseInt(this.datoAtencion.edadNacDays, 10) || 0;

      const totalDays = (years * daysInYear) + (months * 30) + days;
      
      // Calcular la edad en años, redondeada
      const edad = Math.round(totalDays / daysInYear);

      // Navegar a la nueva ruta
      this.$router.push(`/persona_vacunapers/A/${this.p_idAtencion}/${this.datoAtencion.estadoAtencion}/${this.datoAtencion.numero}/${this.datoAtencion.idPersona}/${edad}`)
    },
    agendarCita() {
      window.sessionStorage.setItem("idAtencion", this.datoAtencion.idAtencion);
      this.$router.push('/pacientecita02/' + this.datoAtencion.idPersona + '/' + this.datoAtencion.idEspecialidad + '/' + this.datoAtencion.idMedico);
    },
    abrirIndicacionesPDF() {
      const url = `${config.apiReportesUrl}/1/${this.p_idAtencion}`;
      window.open(url, '_blank');
    },
    abrirCertificadoPDF() {
      const url = `${config.apiReportesUrl}/2/${this.p_idAtencion}`;
      window.open(url, '_blank');
    },

    async obtenerPDF(tipo, idAtencion) {
      const url = `${config.apiReportesUrl}/${tipo}/${idAtencion}`;
      try {
        const response = await api.get(url, { responseType: 'blob' });
        return new Blob([response.data], { type: 'application/pdf' });
      } catch (error) {
        console.error('Error al obtener el PDF:', error);
        return null;
      }
    },
    startDictation(field) {
      this.dictation.startDictation((transcript) => {
        this.datoAtencion[field] = transcript;
      }, this.datoAtencion[field]);
      if (field === "motivo") {
        this.isDictatingMotivo = true;
      } else if (field === "cuadro") {
        this.isDictatingCuadro = true;
      } else if (field === "observacion") {
        this.isDictatingObservacion = true;
      }
    },
    stopDictation(field) {
      this.dictation.stopDictation();
      if (field === "motivo") {
        this.isDictatingMotivo = false;
      } else if (field === "cuadro") {
        this.isDictatingCuadro = false;
      } else if (field === "observacion") {
        this.isDictatingObservacion = false;
      }
    },
    async enviarDocumentosPDF() {
      const indicacionesPDF = await this.obtenerPDF(1, this.p_idAtencion);
      const certificadoPDF = await this.obtenerPDF(2, this.p_idAtencion);

      let formData = new FormData();
      formData.append('recipient', "chechosmart@gmail.com");
      formData.append('msgBody', "Se envía los documentos pdf:");
      formData.append('subject', "Medical Records. Documentos");

      // Asegúrate de convertir los Blob a File para adjuntarlos
      if (indicacionesPDF) {
        // El segundo parámetro de File es el nombre del archivo
        const indicacionesFile = new File([indicacionesPDF], "indicaciones.pdf", { type: 'application/pdf' });
        formData.append('attachments', indicacionesFile);
      }
      if (certificadoPDF) {
        const certificadoFile = new File([certificadoPDF], "certificado.pdf", { type: 'application/pdf' });
        formData.append('attachments', certificadoFile);
      }

      try {
        await api.post('/sendHtmlMailWithAttachment', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        console.log("Correo enviado con éxito");
      } catch (error) {
        console.error('Error al enviar el correo:', error);
      }

      // Bitácora
      const datos = {
        estado: 1,
        idBitacora: 0,
        idMedioCom: 2,
        idPersona: this.datoAtencion.idPersona,
        texto: `Se envían los documentos correspondientes a la atención N° ${this.datoAtencion.numero}, brindada en la especialidad de ${this.datoAtencion.nombreEspecialidad}, el día ${this.datoAtencion.fechaCita}.`,
        tipo: 'A'
      };

      try {
        const response = await api.post('/bitacoras', datos, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
        console.log(response.data);
      } catch (error) {
        console.error(error);
      }
      // Bitácora

    },
    fetchMotivos() {
      api.get('/vwmotivos')
        .then(response => {
          this.motivos = response.data;
        })
        .catch(error => {
          console.error('Error fetching motivos:', error);
        });
    },
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    },
    resetSelection() {
      this.datoAtencion.idMotivo = '';
    },
    verAtencionObstetrica(){
      this.$router.push('/atenobstform/' + this.p_idAtencion + '/' + this.datoAtencion.numero + '/' + this.datoAtencion.estadoAtencion);
    },
    onConsentimientoFirmado() {
      swal2.fire({
        title: '¡Firmado!',
        text: 'Consentimiento registrado correctamente.',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
    },
abrirModalEspecialidad(nombre) {
  this.modalEspecialidad = nombre;
},
cerrarModalEspecialidad() {
  this.modalEspecialidad = null;
},
  },
}
</script>
<style scoped>
.buttons-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.right-aligned-buttons {
  display: flex;
} 

.bg-dark-gray {
  background-color: gray; /* Color gris oscuro */
}
.tab-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 6px 8px 0;
  flex-wrap: wrap;
}
.tablink {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px 8px;
  border: 1px solid transparent;
  border-bottom: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.tablink:hover { background: #e9ecef; color: #343a40; }
.active-tab {
  background: #fff;
  color: #0d6efd;
  border-color: #dee2e6;
  font-weight: 500;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}
.btn-help {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: blue;
}
.btn-help .material-symbols-outlined {
  font-size: 32px;
}
.btn-help:hover {
  opacity: 0.75;
}
.modal-especialidad-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-especialidad-dialog {
  background: #fff;
  border-radius: 10px;
  width: 95vw;
  max-width: 1100px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.modal-especialidad-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  border-bottom: 1px solid #dee2e6;
  font-size: 16px;
}
.modal-especialidad-close {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  display: flex;
  align-items: center;
}
.modal-especialidad-close:hover {
  color: #dc3545;
}
.modal-especialidad-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}
</style>
<style src="@/assets/css/alertas.css" scoped></style>
<style src="@/assets/css/microfono.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>